var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotDate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_9746_20396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.28 7.61113C0.1 7.49113 0 7.17113 0 6.95113C0.14 4.73113 1.06 2.79113 2.78 1.17113C3.44 0.551132 4.18 0.471132 5.06 0.711132C6.36 1.07113 7.54 1.53113 8.48 2.45113C9.14 3.09113 9.1 3.57113 8.66 4.33113C7.74 5.91113 6 8.27113 4.48 9.35113C3.9 9.75113 1.08 8.13113 0.28 7.61113Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9746_20396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.98,
    height: 8.82,
    fill: "white",
    transform: "translate(0 0.589844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotDate);
export default __webpack_public_path__ + "static/media/dot_date.5c9a1cc92286995a957c229acbdd5964.svg";
export { ForwardRef as ReactComponent };